<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <ik-data-table
    entity-name="user_info"
    :model="model"
    icon="mdi-card-account-details-outline"
  />
</template>

<script>

import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import Customer from '@/model/dataLayer/api/takeaway/Customer'

export default {
  components: {
    IkDataTable
  },
  data: function () {
    return ({
      model: Customer
    })
  }
}
</script>
